import { Card, CardActionArea, CardContent, Dialog, DialogContent, DialogTitle, makeStyles, Typography } from '@material-ui/core'
import React from 'react'
import { useSelector } from 'react-redux';
import TableGeneric from '../../compartidos/abms/TableGeneric';

const useStyles = makeStyles((theme) => ({
    root: {
        flexGrow: 1,
        marginTop: theme.spacing(2)
    },
    cardIn: {
        borderTopColor: theme.palette.primary.main,
        borderTopStyle: "outset",
        borderTopWidth: "thick",
        borderRadius: 10,
    }
}));

const CardGeneralesTotalTurnos = ({showLabelFilter}) => {
    const classes = useStyles();

    const { generales } = useSelector(state => state.estadisticasMiOspedyc)

    const [open, setOpen] = React.useState(false);

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
    };

    return (
        <>
            <Card variant="outlined" className={classes.cardIn}>
                <CardActionArea onClick={handleClickOpen}>
                    <CardContent>
                        <Typography variant="h6" color="secondary" align="center">
                            {
                                generales?.turnosPorCentros?.reduce(
                                    (previousValue, currentValue) => {
                                        return previousValue + currentValue.asistidosVirtuales + currentValue.asistidosPresenciales + currentValue.canceladosVirtuales + currentValue.canceladosPresenciales
                                    },
                                    0
                                )
                            }
                        </Typography>
                        <Typography variant="h6" color="secondary" align="center">Total de Turnos</Typography>
                        {
                            showLabelFilter &&
                            <Typography variant='body2' color="textSecondary" align="center" style={{fontSize:12}}>Solo a esta sección corresponden los filtros</Typography>
                        }
                    </CardContent>

                </CardActionArea>
            </Card>
            <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title" maxWidth="md" fullWidth>
                <DialogTitle id="form-dialog-title">Turnos Por Centros</DialogTitle>
                <DialogContent>
                    <TableGeneric
                        data={generales?.turnosPorCentros}
                        columns={[
                            {
                                label: "Centro",
                                id: "nombreCentro",
                                sort: true
                            },
                            {
                                label: "Asistidos Presenciales",
                                id: "asistidosPresenciales",
                                sort: true,
                            },
                            {
                                label: "Asistidos Virtuales",
                                id: "asistidosVirtuales",
                                sort: true,
                            },
                            {
                                label: "Cancelados Presenciales",
                                id: "canceladosPresenciales",
                                sort: true,
                            },
                            {
                                label: "Cancelados Virtuales",
                                id: "canceladosVirtuales",
                                sort: true,
                            }
                        ]}
                    />
                </DialogContent>
            </Dialog>
        </>
    )
}

export default CardGeneralesTotalTurnos